import { Button } from '@material-ui/core';
import styled from 'styled-components';

const AddItemButton = styled(Button).attrs({
  variant: 'text',
})`
  && span.MuiButton-label {
    text-transform: initial;
  }
  &&.MuiButton-root {
    color: #53c4e6;
    & :hover {
      opacity: 0.8;
    }
  }
  &&span.MuiTouchRipple-root {
    opacity: 0.8;
    color: '#53c4e6';
  }
`;

export default AddItemButton;
